export const SAVE_TOKENS = 'SAVE_TOKENS'
export const SAVE_FILTERED_TOKENS = 'SAVE_FILTERED_TOKENS'
